module.exports = __webpack_public_path__ + "static/img/mb_about_banner.310b154.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/mb_about_banner.png
// module id = +Qa+
// module chunks = 1